import { FC } from 'react';
import { Modal } from 'antd';
import AddNut from './addNut';
import NutList from './NutList';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadNuts } from './NutSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { AppState } from '../../redux/store/rootReducer';
import { loadNutMaterials } from '../NutMaterial/NutMaterialSlice';
import { loadNutShapes } from '../NutShape/NutShapeSlice';
const NutPage: FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen, setModelChange, contextHolder, setEditBodySize, editBodySize } = React.useContext(CommonContext) as CommonContextType;
  const Nuts = useSelector(
    (state: AppState) => state.Nuts
  );
  const showModal = () => {
    setModelChange(true);
  };
  const handleCancel = () => {
    setEditBodySize(null)
    setModelChange(false);
  };

  React.useEffect(() => {
    dispatch(loadNuts());
    dispatch(loadNutMaterials());
    dispatch(loadNutShapes());
  }, [dispatch]);
  return (
    <div className='padding' style={{ background: '#ffffff' }}>
      {contextHolder}
      <br></br>
      <h2>Nut List
        <button className='top-button' onClick={showModal}>Create</button>
      </h2>
      <br></br>
      <NutList />
      <Modal title={editBodySize?.id ? 'Edit Nut' : 'Create Nut'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null}>
        <AddNut />
      </Modal>
    </div>
  );

};

export default NutPage;